var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentinline = function SvgDocumentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0v24h18.462V6.087l-.26-.289L15.663.26 15.376 0H3Zm1.846 1.846h9.23v5.539h5.54v14.769H4.845V1.846Zm11.077 1.327 2.365 2.365h-2.365V3.173ZM7.615 9.231v1.846h9.231V9.23h-9.23Zm0 3.692v1.846h9.231v-1.846h-9.23Zm0 3.692v1.847h9.231v-1.847h-9.23Z"
  })));
};
export default SvgDocumentinline;